import clsx, { ClassValue } from 'clsx';

/**
 * Utility function to merge Tailwind classes
 * Prevents class conflicts and duplicates
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
